export default class LoadImages {

	constructor(urls, callback) {

		this.callback = callback;
		this.images = [];
		this.imagesToLoad = urls.length;

		this.imageLoaded = this.imageLoaded.bind(this);

		var i, l, img;
		for (i=0, l=urls.length; i<l; i++) {
			img = new Image();
			this.images.push(img);

			img.addEventListener('load', this.imageLoaded);
			img.src = urls[i];
		}
	}

	imageLoaded() {
		this.imagesToLoad -= 1;
		if (this.imagesToLoad === 0) {
			for (var i=0, l=this.images.length; i<l; i++) {
				this.images[i].removeEventListener('load', this.imageLoaded);
			}
			this.callback(this.images);
			delete this.callback;
			delete this.images;
			delete this.imagesToLoad;
		}
	}

}
